import {ConnectionRoleError} from 'src/utils/platformConnectionValidation'

type ConnectionRoleErrorAlertProps = {
  error: ConnectionRoleError
}

const ConnectionRoleErrorAlert = ({error}: ConnectionRoleErrorAlertProps) => (
  <div className='alert alert-danger py-3 mb-5'>
    {typeof error === 'string' ? (
      error
    ) : (
      <>
        <div className='fw-bold mb-1'>{error.title}</div>
        <div>{error.message}</div>
      </>
    )}
  </div>
)

export default ConnectionRoleErrorAlert
